import { render, staticRenderFns } from "./MultiActions.vue?vue&type=template&id=f8b4d952"
import script from "./MultiActions.vue?vue&type=script&lang=js"
export * from "./MultiActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports